// extracted by mini-css-extract-plugin
export default {"specialRequestIcon":"SpecialRequestTooltip_specialRequestIcon__DQdIp"};